//*Libraries imports
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaMailBulk } from "react-icons/fa";
import { MdStorefront } from "react-icons/md";

//*Icons Imports
import HomeIcon from "@mui/icons-material/Home";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import GroupsIcon from "@mui/icons-material/Groups";
import RateReviewIcon from "@mui/icons-material/RateReview";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";

//*Components Imports
import HorizontalItems from "./HorizontalItems";
import VerticalItems from "./VerticalItems";

//*Styles Imports
import styles from "./styles.module.css";
import login_button_style from "components/SpecificStyles/login_button.module.css";

//*Assets Imports
import logo_black from "../../assets/static/logo/main_black.png";
import logo_white from "../../assets/static/logo/main_white.png";

function Navbar({ on_top, setOnTop, dark_mode, setForceOnTop }) {
  const location = useLocation();
  const navigate = useNavigate();

  const nav_links = [
    {
      name: "Home",
      link: "/",
      element_id: "#home",
      icon: HomeIcon,
    },
    {
      name: "Quem somos",
      link: "/",
      element_id: "#quem-somos",
      icon: GroupsIcon,
    },
    {
      name: "Serviços",
      link: "/",
      element_id: "#servicos",
      icon: MiscellaneousServicesIcon,
    },
    {
      name: "Blog",
      link: "/blog/navegar",
      icon: RateReviewIcon,
    },
    {
      name: "Trabalhe Conosco",
      link: "/trabalhe-conosco",
      icon: GroupAddIcon,
    },
    {
      name: "Cadastre sua loja",
      link: "/cadastro-loja",
      icon: MdStorefront,
      mobile_only: true,
    },
  ];

  const scrollTo = (element_id) => {
    if (location.pathname === "/") {
      const element = document.querySelector(element_id);
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { replace: true });
      // after navigate to home, scroll to element
      setTimeout(() => {
        const element = document.querySelector(element_id);
        element.scrollIntoView({ behavior: "smooth" });
      }, 500);
    }
  };

  useEffect(() => {
    // scroll to top
    window.scrollTo(0, 0);
    const isHome = location.pathname === "/";
    const isCadastro = location.pathname === "/cadastro-loja" || location.pathname === "/cadastro-loja/";

    if (!isHome && !isCadastro) {
      setOnTop(false);
      setForceOnTop(true);
    } else {
      setOnTop(true);
      setForceOnTop(false);
    }
  }, [location]);

  // responsive menu
  const [openMenu, setOpenMenu] = useState(false);

  return (
    <nav
      id="main-navbar"
      data-testid="main-navbar"
      aria-label="Navegação Principal"
      // NavbarContainer = main styles
      // Transition = main transition
      // NavbarOnTop = styles when navbar is on top
      className={
        styles.NavbarContainer +
        " " +
        "Transition-1" +
        (on_top ? " " + styles.NavbarOnTop : "")
      }
    >
      {/* responsive menu items */}
      <VerticalItems
        {...{
          openMenu,
          setOpenMenu,
          nav_links,
          scrollTo,
          styles,
          logo_white,
          logo_black,
          navigate,
          dark_mode,
        }}
      />
      <div
        className={"Transition-1"}
        style={{
          maxWidth: on_top ? "100%" : "1536px",
          width: "100%",
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: on_top
            ? "0.6rem 0.6rem 0.6rem 2rem"
            : "0.6rem 0.6rem 0.6rem 2rem",
          marginBottom: "0",
          borderRadius: "5rem",
          zIndex: 100,
          backgroundColor: on_top ? "transparent" : "var(--navbar-color)",
          backdropFilter: on_top ? "none" : "blur(1.5rem)",
          boxShadow: on_top
            ? "none"
            : "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px",
        }}
      >
        <a
          href="/"
          id="logo-link"
          data-testid="logo-link"
          aria-label="Voltar para Home"
        >
          <img
            className={"Transition-1"}
            src={`${dark_mode ? logo_black : logo_white}?v=1.1`}
            alt="Logotipo da IGooB"
            style={{
              width: on_top ? "10rem" : "8rem",
            }}
          />
        </a>

        {/* main items */}
        <HorizontalItems
          {...{ on_top, nav_links, scrollTo, styles, navigate }}
        />

        <div
          className="Transition-1"
          style={{
            width: on_top ? "auto" : "auto",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "0.8rem",
          }}
        >
          <button
            id="download-button"
            data-testid="download-button"
            aria-label="Baixar aplicativo"
            onClick={() => scrollTo("#download")}
            className={`Transition-1 ${login_button_style.loginButton}`}
            style={{
              position: "relative",
              letterSpacing: "0.1rem",
              perspective: "1500px",
              display: "flex",
              alignItems: "center",
              backgroundColor: "#EEB547",
              color: "#000",
              border: "none",
              cursor: "pointer",
              padding: "0.6rem 1.2rem",
            }}
          >
            <div
              className={`${login_button_style.cardFlipEffect} Transition-1`}
            />
            <span
              style={{ zIndex: 2, position: "relative", whiteSpace: "nowrap" }}
            >
              Baixe agora
            </span>
          </button>

          <Link
            to={"/cadastro-loja/"}
            id="register-store-link"
            data-testid="register-store-link"
            aria-label="Link para cadastro de loja"
          >
            <button
              id="register-store-button"
              data-testid="register-store-button"
              aria-label="Cadastrar sua loja"
              className={`Transition-1 ${login_button_style.loginButton}`}
              style={{
                position: "relative",
                letterSpacing: "0.1rem",
                perspective: "1500px",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                padding: "0.6rem 1.2rem",
                backgroundColor: "rgba(9, 69, 203, 0.1)",
              }}
            >
              <div
                className={`${login_button_style.cardFlipEffect} Transition-1`}
              />
              <MdStorefront
                style={{
                  display: "flex",
                  zIndex: 2,
                  fontSize: "1.4rem",
                }}
                aria-hidden="true"
              />
              <span style={{ zIndex: 2, position: "relative", whiteSpace: "nowrap" }}>
                Cadastre sua loja
              </span>
            </button>
          </Link>

          <Link to={"/contato"}>
            <button
              className={`Transition-1 ${login_button_style.loginButton}`}
              style={{
                position: "relative",
                letterSpacing: "0.1rem",
                perspective: "1500px",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                padding: "0.6rem 1.2rem",
              }}
            >
              <div
                className={`${login_button_style.cardFlipEffect} Transition-1`}
              />
              <FaMailBulk
                style={{
                  display: "flex",
                  zIndex: 2,
                  fontSize: "1.3rem",
                }}
                className="Transition-1"
              />
              <span style={{ zIndex: 2, position: "relative" }}>Contato</span>
            </button>
          </Link>

          <MenuRoundedIcon
            onClick={() => setOpenMenu(true)}
            sx={{
              display: { xs: "block", md: "flex", lg: "none" },
              fontSize: "2.5rem",
            }}
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
